import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PresentStateService {
  private listState: any = null;

  setListState(state: any): void {
    this.listState = { ...state };
  }

  getListState(): any {
    return this.listState;
  }

  clearListState(): void {
    this.listState = null;
  }
}
